import headerShrink from "../helpers/headerShrink";

class StickyHeader extends HTMLElement {
  constructor() {
    super();

    this.targets = document.querySelectorAll("[data-header-target]");
    this.sticking = false;

    const setHeightVariable = () => {
      const shrink = headerShrink();
      // Stuck, the header is already shrunk — add it back so both variables
      // describe the resting header whatever state it is measured in.
      const height =
        this.getBoundingClientRect().height + (this.sticking ? shrink : 0);
      const style = document.documentElement.style;

      style.setProperty("--header-height", `${height}px`);
      // What the header measures once it has stuck and shrunk — the offset for
      // anything that needs to sit directly below it while scrolling.
      style.setProperty("--header-height-sticking", `${height - shrink}px`);
    };

    // A resize would otherwise measure the header part-way through the logo's
    // width transition and store an in-between height.
    const measureWithoutTransition = () => {
      this.classList.add("header--no-transition");
      // Reading the height flushes layout, so the snapped width is in place
      // before the transition goes back on.
      setHeightVariable();
      this.classList.remove("header--no-transition");
    };

    let resizeFrame = null;
    const onResize = () => {
      if (resizeFrame) return;

      resizeFrame = window.requestAnimationFrame(() => {
        resizeFrame = null;
        measureWithoutTransition();
      });
    };

    window.requestAnimationFrame(setHeightVariable);
    window.addEventListener("resize", onResize);

    this._moveStickTarget();
    this._initObserver();
  }

  _initObserver() {
    const cb = (entries) => {
      entries.forEach((entry) => {
        switch (entry.target.dataset.headerTarget) {
          case "stick":
            this.sticking = !entry.isIntersecting;
            this.classList.toggle("sticking", this.sticking);
            document.body.classList.toggle("header--sticking", this.sticking);
            break;
        }
      });
    };

    const observer = new IntersectionObserver(cb, {});
    this.targets.forEach((target) => observer.observe(target));
  }

  _moveStickTarget() {
    // Moving this element in editor messes things up (sections disappear when you change things)
    // so just skip.
    if (Shopify?.designMode) return;

    // Move stick target before header (but after promo bar, if present)
    // We can't directly place the target there because these are both
    // sections in a section group.
    const target = document.querySelector('[data-header-target="stick"]');
    const header = this.closest(".shopify-section--header");
    header.parentNode.insertBefore(target, header);
  }
}

if (!customElements.get("sticky-header")) {
  customElements.define("sticky-header", StickyHeader);
}
